import React, { useEffect, useRef, useState } from "react";
import { Carousel, Modal } from "react-bootstrap";
import { isEmpty } from "../../../../utils/validation";

const CarouselEvent = ({ photo, width = "100%", borderRadius = 0 }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [imgHeights, setImgHeights] = useState([]);
  const [carouselHeight, setCarouselHeight] = useState("auto");

  const handleImageClick = (index) => {
    setShowModal(true);
    setSelectedIndex(index);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedIndex(0);
  };

  const handleImageLoad = (e, index) => {
    const height =
      (e.target.naturalHeight / e.target.naturalWidth) * e.target.offsetWidth;
    const newHeights = [...imgHeights];
    newHeights[index] = height;
    setImgHeights(newHeights);
    setCarouselHeight(Math.max(...newHeights));
  };

  return !isEmpty(photo) ? (
    <>
      <div
        style={{
          width: width,
          height: carouselHeight,
          transition: "height 0.3s ease",
        }}
      >
        <Carousel fade interval={3000} indicators={true}>
          {photo.map((item, index) => (
            <Carousel.Item key={index}>
              <img
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "500px",
                  objectFit: "contain",
                  borderRadius: borderRadius,
                  cursor: "pointer",
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                src={
                  item.image
                    ? "data:" + item.image_type + ";base64," + item.image
                    : "/no_img.png"
                }
                alt={item.alt || `Immagine ${index + 1}`}
                onClick={() => handleImageClick(index)}
                onLoad={(e) => handleImageLoad(e, index)}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      <ModalCarousel
        show={showModal}
        handleClose={handleClose}
        arrayPhoto={photo}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
      />
    </>
  ) : null;
};

const ModalCarousel = ({
  arrayPhoto,
  selectedIndex,
  setSelectedIndex,
  show,
  handleClose,
}) => {
  useEffect(() => {
    setSelectedIndex(selectedIndex);
  }, [selectedIndex]);

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Body style={{ backgroundColor: "#fff" }}>
        <Carousel
          fade
          indicators={true}
          activeIndex={selectedIndex}
          onSelect={(index) => setSelectedIndex(index)}
        >
          {arrayPhoto.map((item, i) => (
            <Carousel.Item key={i}>
              <img
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "80vh",
                  objectFit: "contain",
                  borderRadius: 0,
                  display: "block",
                  margin: "0 auto",
                }}
                src={
                  item.image
                    ? "data:" + item.image_type + ";base64," + item.image
                    : "/no_img.png"
                }
                alt={item.alt || `Immagine ${i + 1}`}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </Modal.Body>
    </Modal>
  );
};

export default CarouselEvent;
